/** @format */
import { CourseUnitBoxComponent } from '../courseUnit/course-unit-box/course-unit-box.component';
import { courseUnitModule } from '../courseUnit/courseUnit.component';
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { ModuleBoxComponent } from '../module/module-box/module-box.component';
import { prerequisiteGroupEditModalModule } from './prerequisiteGroupEditModal.service';
import prerequisiteGroupEditorTpl from './prerequisiteGroupEditor.tpl.html';

export const prerequisiteGroupEditorModule = 'sis-components.prerequisites.prerequisiteGroupEditor';

(function () {
    prerequisiteGroupEditorCtrl.$inject = ['$timeout', 'prerequisiteGroupEditModal'];
    angular
        .module(prerequisiteGroupEditorModule, [
            courseUnitModule,
            prerequisiteGroupEditModalModule,
            errorServiceModule,
            ModuleBoxComponent.downgrade.moduleName,
            CourseUnitBoxComponent.downgrade.moduleName,
        ])
        .component('prerequisiteGroupEditor', {
            template: prerequisiteGroupEditorTpl,
            controller: prerequisiteGroupEditorCtrl,
            bindings: {
                prerequisites: '<',
                parentForm: '<',
            },
        });

    function prerequisiteGroupEditorCtrl($timeout, prerequisiteGroupEditModal) {
        var $ctrl = this;
        $ctrl.menuOptions = [];

        $ctrl.getMenuOptions = index => {
            // Each group needs its own menu options array. The option arrays are initialized lazily when requested, and then
            // stored in an array, as re-building them each time they're requested would cause an infinite digest cycle loop.
            while (index >= $ctrl.menuOptions.length) {
                const i = $ctrl.menuOptions.length;
                $ctrl.menuOptions.push([
                    { name: 'STUDIES.PREREQUISITES_EDITOR.REMOVE_PREREQUISITE_GROUP', action: () => $ctrl.removePrerequisiteGroup(i) },
                    { name: 'STUDIES.PREREQUISITES_EDITOR.EDIT_PREREQUISITE_GROUP', action: () => $ctrl.editPrerequisiteGroup(i) },
                ]);
            }
            return $ctrl.menuOptions[index];
        };

        $ctrl.addNewPrerequisiteGroup = function () {
            $ctrl.prerequisites.push({
                prerequisites: [],
            });
            $ctrl.editPrerequisiteGroup($ctrl.prerequisites.length - 1);
            $ctrl.parentForm.$setDirty();
        };

        $ctrl.removePrerequisiteGroup = function (index) {
            $ctrl.prerequisites.splice(index, 1);
            $ctrl.parentForm.$setDirty();
        };

        $ctrl.editPrerequisiteGroup = function (index) {
            var prerequisiteGroup = _.cloneDeep($ctrl.prerequisites[index]);
            prerequisiteGroupEditModal
                .open(prerequisiteGroup)
                .then(function (result) {
                    $timeout(() => {
                        if (_.get(result, 'prerequisites.length') > 0) {
                            $ctrl.prerequisites[index] = result;
                            $ctrl.parentForm.$setDirty();
                        } else {
                            $ctrl.removePrerequisiteGroup(index);
                        }
                    });
                })
                .catch(function () {
                    if (_.get($ctrl.prerequisites[index], 'prerequisites.length') === 0) {
                        $timeout(() => $ctrl.removePrerequisiteGroup(index));
                    }
                });
        };
    }
})();
